import { all, fork, call, put, takeLatest } from 'redux-saga/effects';
import {
  Types as IssuerDashboardTypes,
  Creators as IssuerDashboardActions,
} from '../ducks/IssuerDashboard';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getIssuerTopNumbers() {
  try {
    const { status, data } = yield call(api.get, '/issuer-dashboard/top-numbers');
    if (status === 200) {
      yield put(
        IssuerDashboardActions.getIssuerTopNumbersSuccess(data)
      );
    } else {
      Sentry.captureMessage('getIssuerTopNumbers failed: status not 200', {
        level: 'error',
        extra: { status, data },
      });
      yield put(
        IssuerDashboardActions.getIssuerTopNumbersError(
          'Error listing topnumbers'
        )
      );
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { message: "Dont have payload" } });
    yield put(
      IssuerDashboardActions.getIssuerTopNumbersError(
        'Error listing topnumbers'
      )
    );
  }
}

function* getIssuerTopNumbersWatcher() {
  yield takeLatest(
    IssuerDashboardTypes.GET_ISSUER_TOP_NUMBERS,
    getIssuerTopNumbers
  );
}


export default function* rootSaga() {
  yield all([
    fork(getIssuerTopNumbersWatcher),
  ]);
}
